import vue from "vue";
import ApiService from "@/common/ApiService";

var apiUrl = '';
var apiService = null;
fetch(process.env.BASE_URL + "urlConfig.json")
  .then((response) => response.json())
  .then((config) => {
    apiUrl = config.userManagementBaseAddress;
     apiService = new ApiService(apiUrl, {
        'Content-Type': 'application/json; charset=utf8'
    });
  })




export default ({

    state: {
        user: {},
        isAuthenticated: false,
        userId: "",
    },

    mutations: {
    },

    getters: {
        UserInfo(state) {
            return state.user;
        },
    },

    actions: {

        async CheckEmailExist(context, data) {
            const response = await apiService.Post("Signup/PdkCheckEmailExist?email=" + data);
            return (response);

        },
        async GetUserInfo(context, id) {

            try {
                const response = await apiService.Get("Signup/" + id);
                // context.commit("SetUserlInfo", response.data);
                localStorage.setItem("UserId", localStorage.getItem('UserId'));


                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async ChangePassword(context, data) {

            try {
                const response = await apiService.Post("users/userChangePassword", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        //change in login
        async clientChangeUserPassword(context, data) {

            try {
                const response = await apiService.Post("users/clientChangeUserPassword ", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async forgetPassword(context, data) {
            try {
                const response = await apiService.Post("/Users/ForgotPassword", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async resetPassword(context, data) {
            try {
                const response = await apiService.Post("/Users/ResetPassword", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async confirmEmail(context, data) {
            try {
                const response = await apiService.Post("/Users/confirmEmail", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async resendConfirmationEmail(context, data) {
            try {
                const response = await apiService.Post("/Users/SendConfirmationEmail", data);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async getRoleResourceByRoleId(context, id) {
            try {
                const response = await apiService.Post("/SecurityManagement/GetRoleResourceByRoleId/" + id);

                return (response);
            } catch (err) {
                console.log(err);
            }
        },




    }

});